<template>
   <div class="login-form">
    <div class="loginWrap">
      <h6 class="tt">ADMIN LOGIN</h6>
      <div class="inner">
        <div class="input-box dflexS">
          <i class="fi fi-rr-user"></i>
          <input type="text" placeholder="접속ID" id="adminId" ref="siteId" v-model="model.siteId" @keyup.enter="onSubmit" />
        </div>
        <div class="input-box dflexS">
          <i class="fi fi-rr-lock"></i>
          <input type="password" placeholder="비밀번호" id="adminPw" ref="sitePass" v-model="model.sitePass" @keyup.enter="onSubmit" />
        </div>
        <div class="dflexS captcha-box">
          <VueClientRecaptcha
              :width="120"
              :value="inputValue"
              :count="4"
              chars="1234"
              :hideLines="true"
              custom-text-color="black"
              @getCode="getCaptchaCode"
              @isValid="checkValidCaptcha"
          >
            <template>
              <span style="color: blue">with Custom Text Or Icon</span>
            </template>
          </VueClientRecaptcha>
          <input
              v-model="inputValue"
              placeholder="자동입력방지코드"
              class="input"
              type="text"
              @keyup.enter="onSubmit"
          />
        </div>
        <p v-if="loginError" role="alert">{{ loginError }}</p>
        <button class="signIn" type="button" :disabled="isSubmitting" @click="onSubmit">{{ isSubmitting ? '처리 중...' : (menuPending ? '메뉴 다시 불러오기' : 'LOGIN') }}</button>
      </div>
    </div>
    <p class="loginFooter">admin <span>cube</span> ver 1.0.1</p>
  </div>

  <div class="modal-wrapper" v-if="modalActive">
    <div class="modal-wrap">
      <div class="sub-title">
        <h3>OTP Verification</h3>
        <a href='#' @click="modalActive = false"><img :src="require('@/assets/img/icon_closeR.svg')" /></a>
      </div>
      <div class="page-content">
        <div class="input-box dflexS">
          <input type="text" ref="otp" v-model="otp" @keyup.enter="optSubmit" />
        </div>
        <div class="status-change-btn-wrap pt50">
          <button class="signIn" type="button" :disabled="isSubmitting" @click="optSubmit()">{{ isSubmitting ? '처리 중...' : '확인하기' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSiteData, setAuthData, getAuthToken } from '@/libs/auth-helper'
import { signIn } from '@/api/member'
import store from '@/store'

import VueClientRecaptcha from 'vue-client-recaptcha'

export default {
  name: 'Login',
  components: {
    VueClientRecaptcha
  },
  data () {
    return {
      isSubmitting: false,
      menuPending: false,
      loginError: '',
      model: {
        siteId: '',
        sitePass: ''
      },
      otp: '',
      modalActive: false,
      data: {
        captchaCode: null,
        isValid: false
      },
      inputValue: null
    }
  },
  computed: {
    canSubmit () {
      return this.model.siteId && this.model.sitePass
    }
  },
  created () {

  },
  methods: {
    /*inputc (ck) {
      document.querySelector('#' + ck).scrollIntoView({ behavior: 'smooth' })
   },*/
    setReloadCaptcha () {
      setTimeout(() => {
        if (document.querySelector('.vue_client_recaptcha_icon')) {
          document.querySelector('.vue_client_recaptcha_icon').click()
        }
      }, 500)
    },
    getCaptchaCode (value) {
      this.data.captchaCode = value
    },
    checkValidCaptcha (value) {
      this.data.isValid = value
    },
    goPage () {
      this.$router.replace({ path: '/dash' })
    },
    modalOpen () {
      this.modalActive = true
      this.$nextTick(() => {
        if (this.$refs.otp) {
          this.$refs.otp.focus()
        }
      })
    },
    modalClose () {
      this.modalActive = false
      this.model.siteId = ''
      this.model.sitePass = ''
      this.otp = ''
    },
    async optSubmit () {
      if (this.isSubmitting) return
      if (this.menuPending) return this.retryMenu()
      if (!this.otp) {
        alert('otp를 입력해주세요.')
        this.$nextTick(() => {
          this.$refs.otp.focus()
        })
        return
      }
      const params = { ...this.model, otp: this.otp }
      this.isSubmitting = true
      this.loginError = ''
      try {
        const res = await signIn(params)
        if (res.resultCode === '0') {
          setAuthData(res.data)
          this.modalActive = false
          this.menuPending = true
          await this.loadLoginMenu()
        } else {
          alert('인증 실패, 다시 시도해주세요.')
        }
      } catch (err) {
        this.loginError = '로그인 서버에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.'
        alert(this.loginError)
      } finally {
        this.isSubmitting = false
      }
    },
    async loadLoginMenu () {
      try {
        await store.dispatch('storeMenuDate')
        this.menuPending = false
        this.loginError = ''
        this.goPage()
      } catch (err) {
        this.menuPending = !!getAuthToken()
        this.loginError = this.menuPending
          ? '로그인은 완료됐지만 메뉴를 불러오지 못했습니다. 메뉴 다시 불러오기를 눌러주세요.'
          : '로그인 세션이 종료되었습니다. 다시 로그인해주세요.'
      }
    },
    async retryMenu () {
      if (this.isSubmitting) return
      if (!getAuthToken()) {
        this.menuPending = false
        this.loginError = '로그인 세션이 종료되었습니다. 다시 로그인해주세요.'
        return
      }
      this.isSubmitting = true
      try {
        await this.loadLoginMenu()
      } finally {
        this.isSubmitting = false
      }
    },
    async onSubmit () {
      if (this.isSubmitting) return
      if (this.menuPending) return this.retryMenu()
      this.loginError = ''
      if (!this.data.isValid) {
        alert('자동 입력 방지 코드를 확인해주세요.')
        setTimeout(() => {
          if (document.querySelector('.vue_client_recaptcha_icon')) {
            document.querySelector('.vue_client_recaptcha_icon').click()
          }
        }, 500)

        return false
      }

      if (!this.canSubmit) {
        for (const child in this.model) {
          if (!this.model[child]) {
            alert(this.$t(`alert.login.${child}`))
            this.$refs[child].focus()
            break
          }
        }
        return
      }

      this.isSubmitting = true
      try {
        const res = await signIn(this.model)
        const resData = res.data
        const succ = res.resultCode
        if (succ === '0') {
          const otp = resData.useOtp
          if (otp === 'N') {
            setAuthData(resData)
            this.menuPending = true
            await this.loadLoginMenu()
          } else if (otp === 'Y') {
            this.modalOpen()
          } else {
            this.loginError = '로그인 응답을 확인하지 못했습니다. 잠시 후 다시 시도해주세요.'
          }
        } else if (succ === '5000') {
          this.setReloadCaptcha()
          this.otp = ''
          this.modalOpen()
        } else {
          this.setReloadCaptcha()
          this.loginError = '로그인 실패, 다시 시도해주세요.'
        }
      } catch (err) {
        this.setReloadCaptcha()
        this.loginError = '로그인 서버에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.'
      } finally {
        this.isSubmitting = false
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    const token = getAuthToken()
    const siteInfo = getSiteData()
    if (token && siteInfo) {
      next('/member')
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.login-form {
   position: fixed;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.login-form h1 {text-align: center;font-size: 47px;color: #fff;font-family: 'GillSansNova';}
.login-form h2 {text-align: center;font-size: 25px; color: #fff; margin-bottom: 75px;}
.loginWrap {
  width: 404px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  background: #131b29;
  border-radius: 10px;
  overflow: hidden;
}
.loginWrap h6 {background: #1a2230;display: flex;align-items: center;justify-content: center;height: 50px;font-size: 21px;font-weight: 700;}
.loginWrap .inner {padding: 20px;display: flex;flex-direction: column;gap: 15px;}
.input-box {
  position: relative;
  width: 100%;
  border: 1px solid #313a49;
  border-radius: 8px;
  overflow: hidden;
  padding:0 0px 0 10px;
  height: 44px;gap: 10px;
}
.input-box img {
  width: 18px;
  margin-right: 20px;
}
.input-box input {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  background:none;
  font-size: 14px;
  color: #fff;
  border: 0 !important;
  padding:0 0 0 15px;
}
.input-box input[type="password"] {
  letter-spacing: 4px;
}
.input-box input::placeholder {
  letter-spacing: 0px;
  color: #bfbfbf;
  font-size: 14px;
}
.inputchk-box {display: flex;align-items: center;gap: 7px;color: #fff;}
.inputchk-box input {border: 1px solid #545454;width: 19px;height: 19px;}
.signIn {
  width: 100%;
  height: 44px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  background: #30ba79;
  border: 1px solid #30ba79;
  color: #fff;
  cursor: pointer;
}
.signIn:hover {
  filter: brightness(1.1);
}
.loginFooter {
  color: #8a8a8c;
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
}
.loginFooter span {
  color: #30ba79;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
  align-items: center;
}
.signIn.close {
  background: red;
  border: 2px solid red;
}
.signIn.close:hover {
  background: #fff;
  color: red;
}
.sub-title {
  font-size: 14px;
  height: 42px;
  position: relative;
  margin-bottom: 30px;
  border-bottom: 3px solid #e1534e;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sub-title a {position: absolute;right: 15px;}
.sub-title a img {vertical-align: middle;}
.sub-title > h3 {
  color: #fff;
  padding: 0;
  position: relative;
}
.modal-wrap {
  border: 3px solid #d65b1c;
  min-width: unset;
  width: 24%;
  min-width: 550px;
  background: #353535;
  padding: 0;
  margin: 0;
}
.modal-wrap .input-box {
  width: 400px;
  gap: 25px;
}
.modal-wrap .input-box input {height: 63px;padding: 0;text-align: center;}
.page-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 0 27px;
}
.page-contents-wrap {
  background: none;
  padding: 0;
}
.modal-wrap .signIn {
  margin-top: 0;
  width: 100%;
  background: #30ba79;
  width: 168px;
  height: 35px;
  font-size: 18px;
  font-weight: normal;
}
.modal-wrap .signIn:hover {
  background: #fff;
  color: #30ba79;
}
.status-change-btn-wrap {
  width: 100%;
  gap: 5px;
  margin-top: 27px;
}

.captcha-box {

}
.captcha-box .vue_client_recaptcha {
  background-color: #8194ff;
  width: 52%;
  height: 44px;
  display: flex;align-items: center;
  flex-direction: row-reverse;
  border-radius: 5px;padding: 0 10px;
}

.captcha-box .input {
  position: relative;
  float: right;
  width: calc(48% - 15px);
  height: 44px;
  text-align: center;
  font-size:14px;
  letter-spacing: -0.025em;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
  border: solid 1px #313a49;
  background:none;
  color: #fff;
  vertical-align: top;
  margin-left: 15px;
  padding: 0;
  border-radius: 8px;
}

@media (max-width: 500px) {
  .login-form {display: block;padding-top: 50px;}
  .loginWrap{
    width: 350px;
    height: auto;
    background: none;
    padding: 0;
    margin: 0 auto;
  }
  .login-form h1 {font-size: 40px;margin-bottom: 20px;}
  .login-form h2 {display: none;}
  .input-box input{
    height: 43px;
  }
  .signIn {height: 43px;}
  .captcha-box .vue_client_recaptcha{display: flex;width: 60%;height: 42px;}
  .captcha-box .input {
    width: calc(48% - 0px);
    height: 42px;
    margin-left: 10px;
  }
  .modal-wrapper {display: block;}
  .modal-wrap {min-width: 320px;position: fixed;left: 50%;transform: translateX(-50%);top: 65px;}
  .modal-wrap .input-box {width: 100%;}
  .modal-wrap .input-box input {height: 43px;}
}
</style>
<style scoped src="@/assets/fonts/GillSansNova.css"></style>
